import { useState, useEffect } from "react";
import axios from "axios";

axios.defaults.withCredentials = true; // ✅ Allow cookies (CSRF token)

export default function AiAnalytics() {
  const [question, setQuestion] = useState("show me all pending transactions");
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [csrfToken, setCsrfToken] = useState("");

  // ✅ Fetch CSRF token from Django endpoint
  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/csrf/`, {
          withCredentials: true,
        });
        setCsrfToken(res.data.csrfToken);
      } catch (err) {
        console.error("Error fetching CSRF token:", err);
      }
    };

    fetchCsrfToken();
  }, []);

  const askAI = async () => {
    setLoading(true);
    setResponse(null);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/ai-analytics/`,
        { question },
        {
          headers: {
            "X-CSRFToken": "lhspDlt9CpHdgvDMo1uRDxzzJckgPU28", // ✅ Send CSRF token in headers
          },
          withCredentials: true,
        }
      );

      setResponse(res.data);
    } catch (err) {
      setResponse({ error: err.response?.data || err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "20px", maxWidth: "600px" }}>
      <h2>Ask AI (SQL Assistant)</h2> {csrfToken}

      <textarea
        rows="3"
        style={{ width: "100%", marginBottom: "10px" }}
        placeholder="Ask something like: Show me all pending transactions"
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
      />

      <button onClick={askAI} >
        {loading ? "Thinking..." : "Ask AI"}
      </button>

      {response && (
        <div style={{ marginTop: "20px" }}>
          <h3>Response</h3>
          {response.error ? (
            <pre style={{ color: "red" }}>
              {JSON.stringify(response.error, null, 2)}
            </pre>
          ) : (
            <>
              <p>
                <strong>SQL:</strong> {response.sql_query}
              </p>
              <p>
                <strong>Explanation:</strong> {response.explanation}
              </p>
              <h4>Results:</h4>
              <pre>{JSON.stringify(response.results, null, 2)}</pre>
            </>
          )}
        </div>
      )}
    </div>
  );
}
